import { IonContent, IonFooter, IonHeader } from '@ionic/react';
import OrderMethodToolbar from '../../../modals/order-method/OrderMethodToolbar';
import MenuCategoryList from '../../../../../components-library/menu/MenuCategoryList';
import useBasket from '../../../../../hooks/basket/useBasket';
import CartIcon from '../../../assets/icons/CartIcon';
import ProfileToolbar from '../../../components/tool-bars/ProfileToolbar';
import useAuth from '../../../../../hooks/global/useAuth';
import Button from '../../../components/buttons/Button';
import useRouter from '../../../../../hooks/navigation/useRouter';
import { Modals, Routes } from '../../../exports/Enums';
import useModalRouter from '../../../common/hooks/useModalRouter';
import { useTranslation } from 'react-i18next';
import useMobileApp from '../../../../../hooks/mobile-app/useMobileApp';
import { CompiledProduct } from '../../../../../providers/MenuProvider';
import classNames from 'classnames';

export const MENU_TAB_CONTENT_ID = 'menuTabContentId';

const MenuTab = () => {
  const { basketItemsCount } = useBasket();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Menu:MenuTab' });
  const { isLoggedIn } = useAuth();
  const { navigate } = useRouter();
  const { openModal, closeModal, isOpen } = useModalRouter();
  const { insets } = useMobileApp();

  const onProductClick = (product: CompiledProduct): void => {
    if (isOpen) {
      return;
    }
    openModal({
      id: Modals.MenuItem,
      presentation: {
        initialBreakpoint: 1,
        breakpoints: [0, 1],
        handle: false,
      },
      props: {
        openModal: true,
        product: product,
        isFreeItem: product.free_eligible && !product.actual_price,
        onCloseModal: closeModal,
      },
    });
  };

  return (
    <>
      <div
        className="safe-area-top top-0 w-full bg-brand-primary/30"
        style={{
          height: insets.top,
        }}
      />
      <IonContent
        scrollEvents={true}
        id={MENU_TAB_CONTENT_ID}
        className={classNames(
          'relative [&::part(scroll)]:bg-gradient-to-b [&::part(scroll)]:from-brand-primary/30 [&::part(scroll)]:via-white [&::part(scroll)]:to-white',
          {
            '[&::part(scroll)]:pb-[calc(100px)]': basketItemsCount > 0,
            '[&::part(scroll)]:pb-[calc(10px)]': basketItemsCount === 0,
          },
        )}
      >
        <IonHeader>
          <div className="py-sm w-full">
            {isLoggedIn && <ProfileToolbar className="!stroke-black mr-md absolute right-0" />}
            <OrderMethodToolbar className="bg-white !border-mobile-notice  relative">
              <OrderMethodToolbar.CompanyName className="text-gray-700" />
              <OrderMethodToolbar.OrderMethodDetails className="text-black" />
            </OrderMethodToolbar>
          </div>
        </IonHeader>
        <MenuCategoryList onProductClick={onProductClick} className="bg-gray-500" />
      </IonContent>

      {basketItemsCount > 0 && (
        <IonFooter className="pb-7 fixed bottom-0 px-md bg-transparent w-full">
          <Button
            className="relative"
            onClick={() =>
              navigate({
                mobile: {
                  path: Routes.Cart,
                },
              })
            }
          >
            <>
              <span className="absolute left-md">
                <CartIcon className="w-4 stroke-white" />
              </span>
              <span className="absolute right-md">{basketItemsCount}</span>
              {t('buttons.place_order')}
            </>
          </Button>
        </IonFooter>
      )}
    </>
  );
};

export default MenuTab;
